@defer {
<div class="main-wrapper d-flex w-100 overflow-hidden vh-100">
  <!-- partial:sidebar -->
  <app-sidebar></app-sidebar>
  <!-- partial -->
  <div class="page-wrapper d-flex flex-column " style="width: 86vw;flex-grow: 1;">
    <!-- partial:navbar -->
    <app-navbar></app-navbar>
    <!-- partial -->
    <div class="page-content pb-4">
      <div contentAnimate *ngIf="!isLoading">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
}
@loading {
<div *ngIf="isLoading" class="spinner-wrapper">
  <div class="spinner">Loading...</div>
</div>
}
